import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

/**
 * Caixa de erro vermelha padrão (alerta de formulário).
 */
export function ErrorMessage({ children }: Props) {
  return (
    <div
      role="alert"
      className="bg-red-500/10 border border-red-500/30 text-red-400 rounded-lg px-4 py-3 text-sm"
    >
      {children}
    </div>
  );
}
